import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["group", "checkbox"]
  static values = {
    attributeName: String,
    selectAll: String,
    deselectAll: String
  }

  connect() {
    this.updateSelectAllButtonState()
  }

  selectAll() {
    const checkboxes = this.checkboxTargets
    const allChecked = checkboxes.every(checkbox => checkbox.checked)
    checkboxes.forEach(checkbox => checkbox.checked = !allChecked)
    this.updateSelectAllButtonState()
  }

  selectGroup(event) {
    const group = event.currentTarget.closest('[data-grouped-collection-checkboxes-target="group"]')
    const groupCheckboxes = group.querySelectorAll('[data-grouped-collection-checkboxes-target="checkbox"]')
    const allChecked = Array.from(groupCheckboxes).every(checkbox => checkbox.checked)

    groupCheckboxes.forEach(checkbox => checkbox.checked = !allChecked)
    this.updateSelectAllButtonState()
  }

  updateSelectAllButtonState() {
    const checkboxes = this.checkboxTargets
    const allChecked = checkboxes.every(checkbox => checkbox.checked)
    const selectAllButton = this.element.querySelector('[data-action="click->grouped-collection-checkboxes#selectAll"]')

    if (selectAllButton) {
      selectAllButton.textContent = allChecked ? this.deselectAllValue : this.selectAllValue
    }

    // Update group-level select all buttons
    this.groupTargets.forEach(group => {
      const groupCheckboxes = group.querySelectorAll('[data-grouped-collection-checkboxes-target="checkbox"]')
      const groupAllChecked = Array.from(groupCheckboxes).every(checkbox => checkbox.checked)
      const groupSelectAllButton = group.querySelector('[data-action="click->grouped-collection-checkboxes#selectGroup"]')

      if (groupSelectAllButton) {
        groupSelectAllButton.textContent = groupAllChecked ? this.deselectAllValue : this.selectAllValue
      }
    })
  }
}
